export default __webpack_public_path__ + "static/anders-ac9b72de07fee9ee46bc611d8ac74446.jpg";